import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core'
import { moveItemInArray } from '@angular/cdk/drag-drop'
import { Subscription } from 'rxjs'
import { ApiService } from '../api.service'
import { Question } from '../questions'
import Swal from 'sweetalert2'

@Component({
	selector: 'activity-test',
	templateUrl: './activity-test.component.html',
	styleUrls: ['./activity-test.component.scss']
})

export class ActivityTestComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

	loading = true
	error = false
	errors = []

	@Input() id = 0
	@Input() type = ''
	@Input() course = 0
	// @Input() lessonID = 0
	@Input() multitransl = false
	@Input() transl = 'es'

	title = ''
	lesson = 0
	questions: any[] = []

	showReviewHeading = false
	selectedReviewHeading = 0
	reviewHeadings: any[] = []

	showCriteria = false
	selectedCriteria: any[] = []
	criteria: any[] = []

	getActivityTestSub = new Subscription
	addQuestionSub = new Subscription
	editQuestionSub = new Subscription
	moveQuestionSub = new Subscription
	deleteQuestionSub = new Subscription
	saveCriteriaSub = new Subscription
	saveReviewHeadingSub = new Subscription
	uploadAudioSub = new Subscription
	checkErrorsSub = new Subscription
	
	@Output() onClose: EventEmitter<boolean> = new EventEmitter

	constructor(private dataService: ApiService, private renderer: Renderer2) {}

	ngOnInit(): void {
		this.loading = true
	}

	ngAfterViewInit(): void {}
	
	ngOnChanges(): void {
		this.getActivityTest(this.id, this.type)
	}

	ngOnDestroy(): void {
		this.getActivityTestSub?.unsubscribe()
		this.addQuestionSub?.unsubscribe()
		this.editQuestionSub?.unsubscribe()
		this.moveQuestionSub?.unsubscribe()
		this.deleteQuestionSub?.unsubscribe()
		this.saveCriteriaSub?.unsubscribe()
		this.saveReviewHeadingSub?.unsubscribe()
		this.uploadAudioSub?.unsubscribe()
		this.checkErrorsSub?.unsubscribe()
	}

	close() {
		this.onClose.emit(true)
	}

	showEdit(event: Event) {
		let span = event.currentTarget as HTMLSpanElement
		let edit = span.nextElementSibling as HTMLElement
		this.renderer.addClass(span, 'd-none')
		this.renderer.removeClass(edit, 'd-none')
		edit.focus()
	}

	hideEdit(event: Event) {
		let edit = event.currentTarget as HTMLElement
		let span = edit.previousElementSibling as HTMLSpanElement
		this.renderer.addClass(edit, 'd-none')
		this.renderer.removeClass(span, 'd-none')
	}

	handleInput(event: KeyboardEvent, questionIndex: number, optionIndex: number = 0) {
		let key = event.key
		
		let question = this.questions[questionIndex]
		// console.log(question)
		let questionType = question.type

		if (key == ";") {
			return false
		} else if (key == "Escape") {
			this.hideEdit(event)
		} else if (key == "Enter") {
			if (questionType == 'single' || questionType == 'multiple') {
				this.editQuestionOptions(event, questionIndex, optionIndex)
			} 
			/*
			else if (questionType == 'open' || questionType == 'dictation') {
				this.editQuestionSolution(event, question.id, questionIndex)
			}
			*/
		}

		return true
	}

	getActivityTest(activityTest: number, type: string) {
		this.loading = true
		this.error = false
		this.id = activityTest
		this.type = type

		this.checkErrorsSub = this.dataService.checkActivityTestErrors(activityTest, this.multitransl, this.transl)
		.subscribe({
			next: (data) => {
				// console.log(data)
				this.errors = data

				this.getActivityTestSub = this.dataService.getActivityTest(activityTest, type, this.multitransl, this.transl)
				.subscribe({
					next: (data) => {
						// console.log(data)
						this.loading = false
						this.error = false
						this.title = data.name
						this.lesson = data.lesson
						this.questions = data.questions
						this.selectedReviewHeading = data.selected_review_heading
						this.reviewHeadings = data.review_headings
						this.selectedCriteria = data.selected_criteria
						this.criteria = data.criteria
						console.log(this.questions)
					},
					error: (_e) => {
						this.loading = false
						this.error = true
					},
				})
			},
			error: (_e) => {
				this.loading = false
				this.error = true
			},
		})
	}

	addQuestion() {
		if (this.type == 'test' && this.questions.length == 1) {
			Swal.fire('Cuidado', 'Una evaluación sólo puede tener una pregunta.', 'warning')
			return
		}

		let type = 'single'
		let questionSentence = 'Nueva pregunta'
		let questionOptions = ['Opción 1', 'Opción 2']
		let questionSolution = 'Opción 1'
		let questionPos = this.questions.length

		this.addQuestionSub = this.dataService.addQuestion(this.id, type, questionSentence, questionOptions, questionSolution, questionPos)
		.subscribe({
			next: (id) => {
				// console.log(id)
				// console.log(this.questions)
				let newQuestion = new Question(id, this.id, type, questionSentence, questionOptions, questionSolution, questionPos)
				// console.log(newQuestion)
				this.questions.push(newQuestion)
				// console.log(this.questions)
			},
			error: (_e) => {},
		})
	}

	editQuestionType(type: string, questionIndex: number) {
		let question = this.questions[questionIndex]
		let questionId = question.id
		let questionOptions = question.options
		// console.log(question)
		// console.log(type)

		// Change options
		if (type == 'single' || type == 'multiple') {
			if (questionOptions.length == 1 && questionOptions[0] == '') {
				questionOptions = ['Opción 1', 'Opción 2']
			}
		} else if (type == 'open' || type == 'dictation') {
			questionOptions = ['']
		}
		question.options = questionOptions

		// Change solution
		let questionOldSolution = question.solution
		let questionNewSolution = ''
		if (type == 'single') {
			if (questionOldSolution.includes(';')) questionNewSolution = questionOldSolution.split(';')[0]
			else if (questionOldSolution.includes(', ')) questionNewSolution = questionOldSolution.split(', ')[0]
		} else if (type == 'multiple') {
			if (questionOldSolution.includes(',')) questionNewSolution = questionOldSolution.replace(',', ';')
		} else if (type == 'open') {
			questionNewSolution = questionOldSolution.replace(';', ', ')
		}
		if (questionNewSolution.length > 0) question.solution = questionNewSolution
		console.log(questionOldSolution)
		console.log(questionNewSolution)

		// Change type
		question.type = type

		this.editQuestionSub = this.dataService.editQuestion(questionId, type, undefined, questionOptions, questionNewSolution, this.multitransl, this.transl)
		.subscribe({
			next: (_data) => {
				// console.log(data)
				// console.log(question)
				this.questions[questionIndex] = question
			},
			error: (_e) => {},
		})
	}

	editQuestionSentence(event: Event, questionIndex: number) {
		let question = this.questions[questionIndex]
		let questionId = question.id
		
		let input = event.currentTarget as HTMLInputElement
		let sentence = input.value
		console.log(input.value)

		if (sentence == '') {
			Swal.fire('Error', 'No puedes dejar la pregunta vacía.', 'error')
			return
		}
		question.sentence = sentence
		this.hideEdit(event)

		this.editQuestionSub = this.dataService.editQuestion(questionId, undefined, sentence, undefined, undefined, this.multitransl, this.transl)
		.subscribe({
			next: (_data) => {
				// console.log(data)
				this.questions[questionIndex] = question
			},
			error: (_e) => {},
		})
	}

	updateQuestionSolution(event: Event, id: number, type: string) {
		let solution = ''
		
		let target = null
		let savedDiv = null
		if (type == 'open' || type == 'dictation') {
			let btn = event.currentTarget as HTMLButtonElement
			console.log(btn)
			target = btn.parentElement?.querySelector(`textarea[name="question_${id}"]`) as HTMLTextAreaElement
			savedDiv = btn.parentElement?.querySelector(`div.text-success`) as HTMLDivElement
		} else {
			target = event.currentTarget as HTMLInputElement
			savedDiv = target.parentElement?.querySelector(`div.text-success`) as HTMLDivElement
		}
		
		if (type == 'multiple') {
			// console.log(targetName)
			let checkboxes = document.querySelectorAll(`input[type="checkbox"][name="question_${id}"]:checked`)
			// console.log(checkboxes)
			checkboxes.forEach(checkbox => {
				solution += (checkbox as HTMLInputElement).value + ';'
			})
			solution = solution.substring(0, solution.length - 1)
		} else {
			solution = target?.value
		}
		// console.log(solution)

		if (savedDiv != null) {
			savedDiv.classList.remove('d-none')
			setTimeout(() => {
				savedDiv.classList.add('d-none')
			}, 3000)
		}

		return solution
	}
	
	editQuestionSolution(event: Event, questionId: number, questionIndex: number) {
		// console.log(event)
		// console.log(question)
		// console.log(type)

		let question = this.questions[questionIndex]
		let questionType = question.type
		let questionSolution = this.updateQuestionSolution(event, questionId, questionType)
		question.solution = questionSolution
		// console.log(solution)

		this.editQuestionSub = this.dataService.editQuestion(question.id, undefined, undefined, undefined, questionSolution, this.multitransl, this.transl)
		.subscribe({
			next: (_data) => {
				// console.log(data)
				this.questions[questionIndex] = question
				// this.getActivityTest(this.id, this.type)
			},
			error: (_e) => {},
		})
	}

	addOption(questionIndex: number) {
		let question = this.questions[questionIndex]
		let questionId = question.id

		let options = question.options
		options.push('Nueva opción')
		question.options = options
		// let optionsStr = options.join(';')
		this.editQuestionSub = this.dataService.editQuestion(questionId, undefined, undefined, options, undefined, this.multitransl, this.transl)
		.subscribe({
			next: (_data) => {
				// console.log(data)
				// this.getActivityTest(this.id, this.type)
			},
			error: (_e) => {},
		})
	}

	editQuestionOptions(event: Event, questionIndex: number, optionIndex: number) {
		let input = event.target as HTMLInputElement
		let option = input.value
		this.hideEdit(event)
		
		let question = this.questions[questionIndex]
		let questionId = question.id
		let updatedQuestion = this.updateQuestionOptions(question, optionIndex, option)
		updatedQuestion.solution = this.updateQuestionSolution(event, questionId, question.type)
		this.questions[questionIndex] = updatedQuestion
		
		this.editQuestionSub = this.dataService.editQuestion(questionId, undefined, undefined, updatedQuestion.options, undefined, this.multitransl, this.transl)
		.subscribe({
			next: (_data) => {
				// console.log(data)
				this.questions[questionIndex] = updatedQuestion
			},
			error: (_e) => {
				// console.log(error)
				this.questions[questionIndex] = question
			},
		})
	}

	isValidOption(option: string) {
		return option.trim() !== ''
	}

	#cleanOption(option: string) {
		return option.replaceAll(';', ',')
	}

	#addQuestionOption(option: string, optionIndex: number, updatedOptions: any[]) {
		updatedOptions[optionIndex] = option;
	}

	#removeQuestionOption(optionIndex: number, updatedOptions: any[]) {
		updatedOptions.splice(optionIndex, 1);
	}
	
	updateQuestionOptions(question: any, optionIndex: number, option: string): any {
		let updatedQuestion = { ...question };
		let updatedOptions = [...updatedQuestion.options];
	
		if (this.isValidOption(option)) {
			option = this.#cleanOption(option);
			this.#addQuestionOption(option, optionIndex, updatedOptions);
		} else {
			this.#removeQuestionOption(optionIndex, updatedOptions); // Corregido: pasa updatedOptions
		}
	
		updatedQuestion.options = updatedOptions;
		return updatedQuestion;
	}
	  

	removeOption(questionIndex: number, optionIndex: number) {
		let question = this.questions[questionIndex]
		let questionId = question.id
		
		let options = question.options
		options.splice(optionIndex, 1)
		let optionsStr = options.join(';')
		question.options = options

		this.editQuestionSub = this.dataService.editQuestion(questionId, undefined, undefined, options, undefined, this.multitransl, this.transl)
		.subscribe({
			next: (_data) => {
				// console.log(data)
				this.questions[questionIndex] = question
			},
			error: (_e) => {},
		})

		return false
	}

	uploadAudio(event: Event, questionId: number, questionIndex: number) {
		let input = event.currentTarget as HTMLInputElement
		console.log(input)
		let audio = input.parentElement?.parentElement?.querySelector(`audio`) as HTMLAudioElement
		console.log(audio)
		let file = input.files?.item(0)!
		let type = file.type
		console.log(file)

		this.uploadAudioSub = this.dataService.uploadAudio(this.course, 'question', questionId, file)
		.subscribe({
			next: (data) => {
				console.log(data)
				this.questions[questionIndex].audio = data
				input.value = ''

				let source = audio.firstElementChild as HTMLSourceElement
				source.src = `${this.dataService.remoteBaseUrl}/www/media/aud/${this.course}/${data}`
				source.type = type
				audio.load()
				// audio.play()
				Swal.fire('Subir nuevo audio', 'Audio reemplazado. Recarga la página para escucharlo.', 'success')
			},
			error: (_e) => {
				// console.log(e)
			},
		})
		
	}

	moveQuestion(index: number, direction: string) {
		// console.log(index)
		// console.log(direction)

		let newIndex = 0
		if (direction === 'up' && index > 0) newIndex = index - 1
		else if (direction === 'down' && newIndex < this.questions.length) newIndex = index + 1

		// console.log(newIndex)
		moveItemInArray(this.questions, index, newIndex)
		// console.log(this.questions)

		this.moveQuestionSub = this.dataService.editQuestionPositions(this.questions)
		.subscribe({
			next: (_data) => {
				// console.log(data)
				// this.getActivityTest(this.id, this.type)
			},
			error: (_e) => {},
		})

		return false
	}

	deleteQuestion(questionIndex: number) {
		Swal.fire({
			title: '¿Seguro?', 
			text: '¿Está seguro de querer borrar esta pregunta?', 
			icon: 'question',
			showCancelButton: true,
			cancelButtonText: 'Cancelar'
		}).then((result) => {
			// console.log(result)
			if (!result.isConfirmed) return
			
			// console.log(questionIndex)
			let question: Question = this.questions[questionIndex]
			let questionId = question.id
			let questionPos = question.position
			// console.log(questionId) 
			this.questions.splice(questionIndex, 1)

			// console.log(this.questions)
			this.deleteQuestionSub = this.dataService.deleteQuestion(questionId, questionPos, this.id)
			.subscribe({
				next: (_data) => {
					// console.log(data)
					// this.getActivityTest(this.id, this.type)
				},
				error: (_e) => {},
			})
		})
		
		return false
	}

	checkCriteria(event: Event) {
		let input = event.currentTarget! as HTMLInputElement
		let name = input.name
		let checkedCriteriaInputs = document.querySelectorAll(`input[type="checkbox"][name="${name}"]:checked`)

		let checkedCriteriaStr = ""
		checkedCriteriaInputs.forEach((input) => {
			checkedCriteriaStr += input.getAttribute('value') + ","
		})
		checkedCriteriaStr = checkedCriteriaStr.slice(0, -1)
		
		this.saveCriteriaSub = this.dataService.saveActivityTestCriteria(this.id, checkedCriteriaStr)
		.subscribe({
			next: (_data) => {
				// console.log(data)
				// this.getActivityTest(this.id, this.type)
			},
			error: (_e) => {},
		})
	}

	saveActivityTestReviewHeading(activityTest: number, reviewHeading: number) {
		this.saveReviewHeadingSub = this.dataService.saveActivityTestReviewHeading(activityTest, reviewHeading)
		.subscribe({
			next: (_data) => {
				// console.log(data)
				// this.getActivityTest(this.id, this.type)
			},
			error: (_e) => {},
		})
	}
}
